import type { OrgPathNode } from '../types';
import { PathLegend } from './PathLegend';
import type { DesignerPath, PathSlotId } from '../types';

// Name and dates deliberately do NOT appear here — they are edited on the
// Cycle Setup step (and the create modal before it). Duplicating them in the
// rail meant the same fields rendered twice on the first screen.
interface DesignerLeftRailProps {
  paths: DesignerPath[];
  activePathId: PathSlotId;
  anchor: OrgPathNode | null;
  onSelectPath: (id: PathSlotId) => void;
  onRenamePath: (id: PathSlotId, name: string) => void;
  onRemovePath: (id: PathSlotId) => void;
  onAddPath: () => void;
}

export function DesignerLeftRail({
  paths,
  activePathId,
  anchor,
  onSelectPath,
  onRenamePath,
  onRemovePath,
  onAddPath,
}: DesignerLeftRailProps) {
  return (
    <aside
      style={{
        width: 240,
        flexShrink: 0,
        background: 'var(--bg-raised)',
        borderRight: '1px solid var(--rule)',
        overflowY: 'auto',
        overflowX: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div style={{ padding: 16, borderBottom: '1px solid var(--rule)' }}>
        <div style={{ fontFamily: 'var(--mono)', fontSize: '0.65rem', letterSpacing: '0.18em', color: 'var(--text-ter)', textTransform: 'uppercase', marginBottom: 10 }}>
          Ball Paths
        </div>
        <p style={{ fontSize: '0.875rem', color: 'var(--text-dim)', marginBottom: 10, lineHeight: 1.45 }}>
          Each path is one ball. Pick the path to edit here, then click units on the chart to add them, top to bottom.
        </p>
        <PathLegend
          paths={paths}
          activePathId={activePathId}
          onSelectPath={onSelectPath}
          onRenamePath={onRenamePath}
          onRemovePath={onRemovePath}
          onAddPath={onAddPath}
        />
      </div>

      {anchor && (
        <div style={{ padding: 16, borderBottom: '1px solid var(--rule)' }}>
          <div style={{ fontFamily: 'var(--mono)', fontSize: '0.65rem', letterSpacing: '0.18em', color: 'var(--text-ter)', textTransform: 'uppercase', marginBottom: 10 }}>
            Org Anchor
          </div>
          <div style={{ fontSize: '0.875rem', color: 'var(--text-sec)', lineHeight: 1.45 }}>
            <strong style={{ color: 'var(--mustard)' }}>{anchor.name}</strong>
            <br />
            {anchor.title}
            <br />
            <span style={{ color: 'var(--text-dim)' }}>All paths start here.</span>
          </div>
        </div>
      )}

    </aside>
  );
}
